<div class="row p-2">
  <div class="col-xl-1 col-lg-1 hidden-md"></div>
  <div class="col-xl-10 col-lg-10 col-md-12 col-sm-12 col-xs-12">
    <div style="padding: 1rem; border-color: #32c832 !important; border: 0.125rem solid transparent;">
      <div><h3>{{ 'pages.worldwatch.complimentaryAccess.heading' | translate }}</h3></div>
      <div><p [innerHTML]="'pages.worldwatch.complimentaryAccess.body' | translate">test</p></div>
    </div>
  </div>
</div>

<div class="row">
    <div class="col-xl-1 hidden-lg"></div>
    <div class="col-xl-10 col-lg-12 col-md-12 col-sm-12 col-xs-12">

        <div class="row" *ngIf="sinceLastLogin != undefined">
            <div class="col-12">
                <div class="alert lastLogin" role="alert">
                    <div style="float:left; width:100%">
                        <a (click)="loadSinceLastVisit();" class="click">
                            <li>{{ 'pages.updates.signal.sinceLastVisitPre' | translate }} {{sinceLastLogin}} {{ 'pages.updates.signal.sinceLastVisitPost' | translate }} </li>
                        </a>
                    </div>
                </div>
            </div>
        </div>

    </div>
    <div class="col-xl-1 hidden-lg"></div>
</div>

<div class="row pb-3">
    <div class="col-xl-1 hidden-lg"></div>
    <div class="col-xl-10 col-lg-12 col-md-12 col-sm-12 col-xs-12">
        <div class="row">
            <div class="col-12">

                <div class="card">
                    <div class="card-body">
                        <div class="card-title justify-content-right">
                            <h6>
                                <div class="custom-control custom-switch right mr-3" style="float:left">
                                    <input type="checkbox" class="custom-control-input" id="advanceSearch" [(ngModel)]="advSearch">
                                    <label class="custom-control-label" for="advanceSearch">{{ 'pages.generic.advancedSearch' | translate }} </label>
                                </div>
                                <div class="custom-control custom-switch right" style="float:left">
                                    <input type="checkbox" class="custom-control-input" id="hideSaveSearch" [(ngModel)]="hideSaveSearch">
                                    <label class="custom-control-label" for="hideSaveSearch">{{ 'pages.generic.savedSearches' | translate }}</label>
                                </div>
                            </h6>
                        </div>
                        <form>
                            <div class="form-row">
                                <div class="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-xs-12 mb-3">
                                    <label for="reference">{{ 'pages.updates.signal.fieldTitles.reference' | translate }} </label>
                                    <input type="text" class="form-control" name="reference" aria-describedby="reference" placeholder="SIG-" [(ngModel)]="reference">
                                </div>
                                <div class="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-xs-12 mb-3">
                                    <label for="query">{{ 'pages.generic.search' | translate }}</label>
                                    <input type="text" class="form-control" name="query" aria-describedby="query" placeholder="Search" [(ngModel)]="query">
                                </div>
                                <div class="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-xs-12 mb-3">
                                    <label for="urgency">{{ 'pages.updates.signal.fieldTitles.urgency' | translate }}</label>
                                    <select class="form-control" name="urgency" aria-describedby="urgency" [(ngModel)]="urgency">
                                        <option></option>
                                        <option>Information</option>
                                        <option>Low</option>
                                        <option>Medium</option>
                                        <option>High</option>
                                        <option>Critical</option>
                                    </select>
                                </div>
                            </div>

                            <div [ngbCollapse]="!advSearch" id="advSearch">
                                <div class="form-row">
                                    <div class="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-xs-12 mb-3">
                                        <label for="category">{{ 'pages.updates.signal.fieldTitles.category' | translate }}</label>
                                        <select class="form-control" name="category" aria-describedby="category" [(ngModel)]="category">
                                            <option></option>
                                            <option>Advisory</option>
                                            <option>Announcement</option>
                                            <option>Breach</option>
                                            <option>Breaking Story</option>
                                            <option>News</option>
                                            <option>Threat</option>
                                            <option>Update</option>
                                            <option>Vulnerability</option>
                                        </select>
                                    </div> 
                                    <div class="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-xs-12 mb-3">
                                        <label for="tags">{{ 'pages.updates.signal.fieldTitles.tags' | translate }}</label>
                                        <input type="text" class="form-control" name="tags" aria-describedby="tags" placeholder="Tags" [(ngModel)]="tags">
                                    </div>
                                    <div class="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-xs-12 mb-3">
                                        <label for="ioc">{{ 'pages.updates.signal.fieldTitles.ioc' | translate }}</label>
                                        <input type="text" class="form-control" name="ioc" aria-describedby="ioc" placeholder="IOC" [(ngModel)]="iocQuery">
                                    </div>
                                    <div class="col-xl-8 col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-3">
                                        <label for="publishDate">{{ 'pages.updates.signal.fieldTitles.publishedFromTo' | translate }}</label>
                                        <div class="row">
                                            <div class="col-6" style="padding-right: 0;">
                                                <input type="date" class="form-control" name="publishFrom" aria-describedby="publishFrom" [(ngModel)]="publishFrom">
                                            </div>
                                            <div class="col-6" style="padding-left: 0;">
                                                <input type="date" class="form-control" name="publishTo" aria-describedby="publishTo" [(ngModel)]="publishTo">
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-xs-12 mb-3">
                                        <label for="sort">{{ 'pages.generic.sort' | translate }}</label>
                                        <div class="row">
                                            <div class="col-8" style="padding-right: 0;">
                                                <select class="form-control" style="float:left;" name="sort" aria-describedby="sort" [(ngModel)]="sort">
                                                    <option></option>
                                                    <option value="date">{{ 'pages.updates.signal.fieldTitles.lastUpdate' | translate }}</option>
                                                    <option value="publishDate">{{ 'pages.updates.signal.fieldTitles.publishDate' | translate }}</option>
                                                    <option value="signalUrgency">{{ 'pages.updates.signal.fieldTitles.urgency' | translate }}</option>
                                                    <option value="mainCategory">{{ 'pages.updates.signal.fieldTitles.category' | translate }}</option>
                                                </select>
                                            </div>
                                            <div class="col-4" style="padding-left: 0;">
                                                <select class="form-control" name="sortOrder" aria-describedby="sortOrder" [(ngModel)]="sortOrder">
                                                    <option></option>
                                                    <option value="-1">DESC</option>
                                                    <option value="1">ASC</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            
                            <button class="btn btn-primary" (click)="search();">{{ 'pages.generic.filter' | translate }}</button>
                            <button class="btn btn-primary" (click)="reset();">{{ 'pages.generic.reset' | translate }}</button>
                            <button class="btn btn-primary" (click)="openSearchModal(saveSearch)" *ngIf="searched">{{ 'pages.generic.saveSearch' | translate }}</button>
                        </form>

                    </div>
                </div>
                
            </div>
        </div>

        <div class="row pt-1" *ngIf="savedSearches && savedSearches.length > 0" [ngbCollapse]="!hideSaveSearch" id="savedSearch">
            <div class="col-12">
                <div class="card">
                    <div class="card-body p-1">
                        <span style="float:left" *ngFor="let search of savedSearches">
                            <button class="btn btn-primary" (click)="loadSearch(search);">{{search.name}}  <fa-icon [icon]="['fas', 'trash']" class="pl-2" (click)="deleteSearch($event, confirmDeleteSearch, search)"></fa-icon></button>
                        </span>
                    </div>
                </div>
            </div>
        </div>
    
    </div>
    <div class="col-xl-1 hidden-lg"></div>
</div>

<div class="row rowfiller">
    <div class="col-xl-1 hidden-lg"></div>
    <div class="col-xl-10 col-lg-12 col-md-12 col-sm-12 col-xs-12">

        <div class="row pt-1">
            <div class="col-12 justify-content-right">

                <fa-icon [icon]="['fas', 'th-list']" size="2x" class="p-1 click" (click)="changeViewType('list')"></fa-icon>
                <fa-icon [icon]="['fas', 'th-large']" size="2x" class="p-1 click" (click)="changeViewType('grid')"></fa-icon>

            </div>
        </div>

        <ul class="nav nav-tabs">
            <li class="nav-item">
                <a class="nav-link" [ngClass]="{ 'active' : page === 'signals' }" (click)="page = 'signals'; latestSignals();">{{ 'pages.updates.signal.signals' | translate }}</a>
            </li> 
            <li class="nav-item">
                <a class="nav-link" [ngClass]="{ 'active' : page === 'flagged' }" (click)="loadFlagged();" >{{ 'pages.generic.flagged' | translate }} <span class="badge badge-primary ml-2" style="padding:0.1rem 0.5rem;" *ngIf="flagRefs">{{flagRefs.length}}</span> </a>
            </li>
            <li class="nav-item">
                <a class="nav-link" [ngClass]="{ 'active' : page === 'analytics' }" (click)="page = 'analytics';  latestSignals(); loadAnalytics();">{{ 'pages.generic.analytics' | translate }}</a>
            </li>
        </ul>

        <br/><br/>

        <div class="row justify-content-center p-5" *ngIf="!chartDataLoaded && page === 'analytics'">
            <div class="spinner-border text-primary" role="status">
                <span class="sr-only">{{ 'pages.generic.loading' | translate }}</span>
            </div>
        </div>

        <div *ngIf="chartDataLoaded && page === 'analytics'">

            <h2> {{ 'pages.generic.thisMonth' | translate }} </h2>

            <div class="row p-1 status-table" *ngIf="chartDataLoaded">
                <div class="col-xl-4 col-lg-4 col-sm-12 item first-col-status">
                    <h4>{{ 'pages.generic.atAGlance' | translate }}<br/><small>{{monthWord}}</small></h4> 
                </div>
                <div class="col-xl-2 col-lg-2 col-md-6 col-sm-6 col-xs-12">
                    <div class="card">
                        <div class="card-body text-center">
                        <h2 class="card-title">{{totalStats}}</h2>
                        <h6 class="card-subtitle mb-2 text-muted">{{ 'pages.generic.new' | translate }}</h6>
                        <a (click)="loadNew('month')" class="btn btn-primary">{{ 'pages.generic.view' | translate }}</a>
                        </div>
                    </div>
                </div>
                <div class="col-xl-2 col-lg-2 col-md-6 col-sm-6 col-xs-12">
                    <div class="card">
                        <div class="card-body text-center">
                        <h2 class="card-title">
                        <span>{{categoryStats | statFilter : 'Breach' }}</span>
                        </h2>
                        <h6 class="card-subtitle mb-2 text-muted">{{ 'pages.updates.signal.breaches' | translate }}</h6>
                        <a (click)="loadCategory('month','Breach')" class="btn btn-primary">{{ 'pages.generic.view' | translate }}</a>
                        </div>
                    </div>
                </div>
                <div class="col-xl-2 col-lg-2 col-md-6 col-sm-6 col-xs-12">
                    <div class="card">
                        <div class="card-body text-center">
                        <h2 class="card-title">
                            <span>{{urgencyStats | statFilter : 'Critical' }}</span>
                        </h2>
                        <h6 class="card-subtitle mb-2 text-muted">{{ 'pages.updates.signal.critical' | translate }}</h6>
                        <a (click)="loadUrgency('month','Critical')" class="btn btn-primary">{{ 'pages.generic.view' | translate }}</a>
                        </div>
                    </div>
                </div>
                <div class="col-xl-2 col-lg-2 col-md-6 col-sm-6 col-xs-12">
                    <div class="card">
                        <div class="card-body text-center">
                        <h2 class="card-title">
                            <span>{{urgencyStats | statFilter : 'High' }}</span>
                        </h2>
                        <h6 class="card-subtitle mb-2 text-muted">{{ 'pages.updates.signal.high' | translate }}</h6>
                        <a (click)="loadUrgency('month','High')" class="btn btn-primary">{{ 'pages.generic.view' | translate }}</a>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-3">
                
                    <highcharts-chart 
                        [Highcharts]="Highcharts"
                        [options]="catPieChartOptions"
                        [(update)]="updateCategoryPie"
                        style="width: 100%; height: 400px; display: block;"
                    ></highcharts-chart>

                </div>
                <div class="col-3">
                
                    <highcharts-chart 
                        [Highcharts]="Highcharts"
                        [options]="urgPieChartOptions"
                        [(update)]="updateUrgencyPie"
                        style="width: 100%; height: 400px; display: block;"
                    ></highcharts-chart>

                </div>

                <div class="col-6">

                    <highcharts-chart 
                        [Highcharts]="Highcharts"
                        [options]="wordChartOptions"
                        [(update)]="updateWordChart"
                        style="width: 100%; height: 400px; display: block;"
                    ></highcharts-chart>

                </div>
            </div>

        </div>

        <div *ngIf="annualChartDataLoaded && page === 'analytics'">

            <h2 class="pt-2"> {{ 'pages.generic.lastYear' | translate }} </h2>

            <div class="row p-1 status-table" *ngIf="annualChartDataLoaded">
                <div class="col-xl-4 col-lg-4 col-sm-12 item first-col-status">
                    <h4>{{ 'pages.generic.atAGlance' | translate }}<br/><small>Last 12 months</small></h4> 
                </div>
                <div class="col-xl-2 col-lg-2 col-md-6 col-sm-6 col-xs-12">
                    <div class="card">
                        <div class="card-body text-center">
                        <h2 class="card-title">{{annualTotalStats}}</h2>
                        <h6 class="card-subtitle mb-2 text-muted">{{ 'pages.generic.total' | translate }}</h6>
                        <a (click)="loadNew('annual')" class="btn btn-primary">{{ 'pages.generic.view' | translate }}</a>
                        </div>
                    </div>
                </div>
                <div class="col-xl-2 col-lg-2 col-md-6 col-sm-6 col-xs-12">
                    <div class="card">
                        <div class="card-body text-center">
                        <h2 class="card-title">
                        <span>{{annualCategoryStats | statFilter : 'Breach' }}</span>
                        </h2>
                        <h6 class="card-subtitle mb-2 text-muted">{{ 'pages.updates.signal.breaches' | translate }}</h6>
                        <a (click)="loadCategory('annual','Breach')" class="btn btn-primary">{{ 'pages.generic.view' | translate }}</a>
                        </div>
                    </div>
                </div>
                <div class="col-xl-2 col-lg-2 col-md-6 col-sm-6 col-xs-12">
                    <div class="card">
                        <div class="card-body text-center">
                        <h2 class="card-title">
                            <span>{{annualUrgencyStats | statFilter : 'Critical' }}</span>
                        </h2>
                        <h6 class="card-subtitle mb-2 text-muted">{{ 'pages.updates.signal.critical' | translate }}</h6>
                        <a (click)="loadUrgency('annual','Critical')" class="btn btn-primary">{{ 'pages.generic.view' | translate }}</a>
                        </div>
                    </div>
                </div>
                <div class="col-xl-2 col-lg-2 col-md-6 col-sm-6 col-xs-12">
                    <div class="card">
                        <div class="card-body text-center">
                        <h2 class="card-title">
                            <span>{{annualUrgencyStats | statFilter : 'High' }}</span>
                        </h2>
                        <h6 class="card-subtitle mb-2 text-muted">{{ 'pages.updates.signal.high' | translate }}</h6>
                        <a (click)="loadUrgency('annual','High')" class="btn btn-primary">{{ 'pages.generic.view' | translate }}</a>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row" *ngIf="annualChartDataLoaded">

                <div class="col-6">
                
                    <highcharts-chart 
                        [Highcharts]="Highcharts"
                        [options]="catAnnualPieChartOptions"
                        [(update)]="updateAnnualCategoryPie"
                        style="width: 100%; height: 400px; display: block;"
                    ></highcharts-chart>

                </div>
                <div class="col-6">
                
                    <highcharts-chart 
                        [Highcharts]="Highcharts"
                        [options]="urgAnnualPieChartOptions"
                        [(update)]="updateAnnualUrgencyPie"
                        style="width: 100%; height: 400px; display: block;"
                    ></highcharts-chart>

                </div>

            </div>

            <div class="row" *ngIf="annualChartDataLoaded">
                <div class="col-12" *ngIf="loadStackedBarUrgency">
                
                    <highcharts-chart 
                        [Highcharts]="Highcharts"
                        [options]="stackedBarUrgencyOptions"
                        [(update)]="updateStackedBarUrgency"
                        style="width: 100%; height: 400px; display: block;"
                    ></highcharts-chart>

                </div>

                <div class="col-12" *ngIf="loadStackedBarCategory">
                
                    <highcharts-chart 
                        [Highcharts]="Highcharts"
                        [options]="stackedBarCategoryOptions"
                        [(update)]="updateStackedBarCategory"
                        style="width: 100%; height: 400px; display: block;"
                    ></highcharts-chart>

                </div>

                <div class="col-12" *ngIf="loadStackedBarBreach">
                
                    <highcharts-chart 
                        [Highcharts]="Highcharts"
                        [options]="stackedBarBreachOptions"
                        [(update)]="updateStackedBarBreach"
                        style="width: 100%; height: 400px; display: block;"
                    ></highcharts-chart>

                </div>

            </div>

        </div>


        <div class="card-body p-t-1 p-0" *ngIf="viewType === 'list' && (page === 'signals' || page === 'flagged')">
            <app-signal-list [signals]="signals" [flagRefs]="flagRefs" [flaggingRef]="flaggingRef" [loaded]="signalsLoaded" (flagEmitter)="flag($event);" (sortEmitter)="sortResults($event);"></app-signal-list>
        </div>

        <div class="card-body p-t-1 p-0" *ngIf="viewType === 'grid' && (page === 'signals' || page === 'flagged')">
            <app-signal-grid [signals]="signals" [flagRefs]="flagRefs" [flaggingRef]="flaggingRef" [loaded]="signalsLoaded" (flagEmitter)="flag($event);"></app-signal-grid>
        </div>

        <div class="card-body justify-content-center p-t-1 p-3" *ngIf="(page === 'signals' || page === 'flagged') && signalsLoaded">
            <ngb-pagination [collectionSize]="signalsCount" pageSize="12" page="currentPage" [(page)]="currentPage" [maxSize]="10" aria-label="Pagination" (pageChange)="onPageChange($event)">
                <ng-template ngbPaginationPrevious></ng-template>
                <ng-template ngbPaginationNext></ng-template>
            </ngb-pagination>
        </div>

    </div>
    <div class="col-xl-1 hidden-lg"></div>
</div>



<ng-template #saveSearch let-modal>
    <form>
        <div class="modal-header">
            <h4 class="modal-title" id="modal-basic-title">{{ 'pages.generic.saveSearchModal' | translate }}</h4>
            <button type="button" class="cancel" aria-label="cancel" (click)="modal.dismiss('close')">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="modal-body">
            <div class="col-12">
                <label for="reference">{{ 'pages.generic.saveSearchName' | translate }}</label>
                <input type="text" class="form-control" name="searchName" aria-describedby="searchName"  [(ngModel)]="searchName">
            </div>
        </div>
        <div class="modal-footer">
            <button type="button" class="btn btn-secondary" [disabled]="!searchName" (click)="modal.close('save')">{{ 'pages.generic.save' | translate }}</button>
            <button type="button" class="btn btn-secondary" (click)="modal.close('close')">{{ 'pages.generic.close' | translate }}</button>
        </div>
    </form>
</ng-template>

<ng-template #confirmDeleteSearch let-modal>
    <form>
        <div class="modal-header">
            <h4 class="modal-title" id="modal-basic-title">{{ 'pages.generic.deleteSearchModal' | translate }}</h4>
            <button type="button" class="cancel" aria-label="cancel" (click)="modal.dismiss('close')">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="modal-body">
            <p>
                {{ 'pages.generic.deleteSearchConfirm' | translate }}
            </p>
        </div>
        <div class="modal-footer">
            <button type="button" class="btn btn-secondary"  (click)="modal.close('delete')">{{ 'pages.generic.confirm' | translate }}</button>
            <button type="button" class="btn btn-secondary" (click)="modal.close('close')">{{ 'pages.generic.close' | translate }}</button>
        </div>
    </form>
</ng-template>